export default function SciPy_Tutorial() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SciPy_Tutorial</h1>
      <p>Content for SciPy_Tutorial goes here.</p>
    </div>
  );
}